export default __webpack_public_path__ + "static/media/tiger_win.957bcc03.gif";